"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
// Hot Module Replacement
__export(require('./helpers'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angularclass/hmr/dist/index.js
// module id = 640
// module chunks = 5